import { Card, CardTitle } from '../../Common/ui/card'
import React, { Fragment, useState } from 'react'
import { Checkbox } from '../../Common/ui/checkbox'
import Input from '../../Common/ui/input'
import { useForm } from 'react-hook-form'
import { ResponsiveBullet } from '@nivo/bullet'
import { useLocation } from 'react-router-dom'
import SelectInput from '../../Common/ui/selectInput'
import { Box, IconButton } from '@mui/material'
import * as RiskTypes from '../../Entities/RiskTypes'
import { IoEyeOutline } from 'react-icons/io5'
import { IoIosInformationCircle } from 'react-icons/io'
import { Button } from '../../Common/ui/button'
import { useTranslation } from 'react-i18next'

const IndicatorView = () => {
    const location = useLocation()
    const [ selectData, setSelectData ] = useState('')
    const [ inputData, setInputData ] = useState('')
    const { register, handleSubmit, formState: { errors, isSubmitting, isLoading }, control } = useForm({
        mode: 'onChange',
        defaultValues: { inputField: inputData, selectInput: selectData }
    })

    const { t } = useTranslation()

    const handleSubmitClick = () => {

    }

    const handleCancel = () => {

    }

    const onValueChange = (value) => {
        setInputData(value.target.value)
    }

    const onValueSelectChange = (e) => {
        setSelectData(e)
    }

    const data = [
        {
            ranges: [ 0, 50, 100, 200, 250, 300 ],
            measures: [0],
            markers: [ 40, 140, 80, 110, 210, 280, 290 ]
        }
    ]

    const CustomMarker = ({ x, size, color }) => {
        const markerWidth = 2
        const markerHeight = size

        return (
            <rect
                x={x - markerWidth / 2}
                width={markerWidth}
                height={markerHeight}
                fill={color}
                rx={2}
                ry={2}
            />
        )
    }

    const tickValues = [ 0, 50, 100, 200, 250, 300 ]
    const tickLabels = [ 'abcd', 'efgh', 'ijkl', 'mnop', 'qrst', 'uvwx' ]

    const theme = {
        axis: {
            domain: {
                line: {
                    stroke: '#ff0000',
                    strokeWidth: 2,
                    display: 'none'
                }
            },
            ticks: {
                line: {
                    stroke: '#ff0000',
                    strokeWidth: 2,
                    display: 'none'
                },
                text: {
                    fill: '#00ff00',
                    fontSize: 12,
                    display: 'none'
                }
            },
            legend: {
                text: {
                    fill: '#0000ff',
                    fontSize: 14,
                    display: 'none'
                }
            }
        }
    }

    return (
        <Fragment className="Indicator-container" >
            <div>
                <Card className=" w-full p-3 h-1/3 rounded-none">
                    <CardTitle>
                        <div className='flex justify-between'>
                            <div className='flex-1 text-primary w-1/4'>
                                {t('OneSide Indicator')}
                            </div>
                            <div className='flex-1 w-2/4' />
                            <div className='flex-1 w-1/4 flex justify-end'>
                                <div className='pl-2 flex flex-row   justify-center items-center' >
                                    <Checkbox /><span className='pl-2 text-[12px]'>{t('Add to Dashboard')}</span>
                                </div>
                                <div className='pl-2 flex flex-row   justify-center items-center' >
                                    <IconButton><IoEyeOutline color='hsl(var(--primary))' /></IconButton><span className='pl-2 text-[12px]'>{t('Preview')}</span>
                                </div>
                                <div className='pl-2 flex flex-row   justify-center items-center' >
                                    <IconButton><IoIosInformationCircle /></IconButton><span className='pl-2 text-[12px]'>{t('About')}</span>
                                </div>
                            </div>
                        </div>
                        <Box display="grid" sx={{ p: 4 }} gridTemplateColumns="repeat(12, 1fr)" gap={2}>
                            <Box gridColumn="span 4">
                                <div style={{ marginBottom: '2%' }}>
                                    <Input label={t('Indicator Name')} register={register} value={inputData} type="text" placeholder={t('Enter Name')} onValueChange={onValueChange} name="Indicator Name" errors={errors} control={control} required rules={{ required: t('Name is Required') }} />
                                </div>
                            </Box>
                            <Box gridColumn="span 4" >
                                <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2}>
                                    <Box gridColumn="span 2">
                                        <div style={{ marginBottom: '2%' }}>
                                            <SelectInput label={t('Category')} required rules={{ required: t('This field is Required') }} control={control} errors={errors} name="Category" placeholder={t('Select Category')} onValueChange={onValueSelectChange} value={selectData} options={RiskTypes.SELECT_OPTIONS} />
                                        </div>
                                    </Box>
                                    <Box gridColumn="span 2">
                                        <div style={{ marginBottom: '2%' }}>
                                            <SelectInput label={t('Risk Nature')} required rules={{ required: t('This field is Required') }} control={control} errors={errors} name="Type" placeholder={t('Select Risk Nature')} onValueChange={onValueSelectChange} value={selectData} options={RiskTypes.SELECT_OPTIONS} />
                                        </div>
                                    </Box>
                                </Box>
                            </Box>
                            <Box gridColumn="span 4" >
                                <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2}>
                                    <Box gridColumn="span 2">
                                        <div style={{ marginBottom: '2%' }}>
                                            <SelectInput label={t('UoM')} required rules={{ required: t('This field is Required') }} control={control} errors={errors} name="UoM" placeholder={t('Select UoM')} onValueChange={onValueSelectChange} value={selectData} options={RiskTypes.SELECT_OPTIONS} />
                                        </div>
                                    </Box>
                                </Box>
                            </Box>
                            <Box gridColumn="span 4" >
                                <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2}>
                                    <Box gridColumn="span 2">
                                        <div style={{ marginBottom: '2%' }}>
                                            <SelectInput label={t('Periodicity')} required rules={{ required: t('This field is Required') }} control={control} errors={errors} name="Periodicity" placeholder={t('Select Periodicity')} onValueChange={onValueSelectChange} value={selectData} options={RiskTypes.SELECT_OPTIONS} />
                                        </div>
                                    </Box>
                                    <Box gridColumn="span 2">
                                        <div style={{ marginBottom: '2%' }}>
                                            <Input label={t('Duration')} register={register} value={inputData} type="text" placeholder={t('Enter Duration')} onValueChange={onValueChange} name="Duration" errors={errors} control={control} />
                                        </div>
                                    </Box>
                                </Box>
                            </Box>
                            <Box gridColumn="span 4" >
                                <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2}>
                                    <Box gridColumn="span 2">
                                        <div style={{ marginBottom: '2%' }}>
                                            <Input label={t('Current')} register={register} value={inputData} type="text" placeholder={t('Enter Current')} onValueChange={onValueChange} name="Current" errors={errors} control={control} required rules={{ required: t('This field is Required') }} />
                                        </div>
                                    </Box>
                                    <Box gridColumn="span 2">
                                        <div style={{ marginBottom: '2%' }}>
                                            <Input label={t('Competitor')} register={register} value={inputData} type="text" placeholder={t('Enter Competitor')} onValueChange={onValueChange} name="Competitor" errors={errors} control={control} />
                                        </div>
                                    </Box>
                                </Box>
                            </Box>
                            <Box gridColumn="span 4" >
                                <Box display="grid" gridTemplateColumns="repeat(4, 1fr)" gap={2}>
                                    <Box gridColumn="span 2">
                                        <div style={{ marginBottom: '2%' }}>
                                            <Input label={t('Industry Standrad')} register={register} value={inputData} type="text" placeholder={t('Enter Industry Standrad')} onValueChange={onValueChange} name="Industry_Standrad" errors={errors} control={control} />
                                        </div>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </CardTitle>
                </Card>
                <Card className=" rounded-none">
                    <div className="flex flex-col">
                        <div className=" flex flex-row justify-center pt-4 w-[100%]">
                            <div style={{ minWidth: '15%', paddingLeft: '.5%' }} className={'w-[15%]'}>
                                <div style={{ width: '50px' }}>
                                    <p className="text-xs text-center">{t('Absolute Lower')}</p>
                                    <Input
                                        value={data[0].markers[0]}
                                        type="text"
                                        name="inputField"
                                        control={control}
                                    />
                                </div>
                                <svg className="mx-4" xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 14" fill="none" >
                                    <path
                                        d="M9.09423 13.5L0.000967753 -3.17432e-07L18.1875 -1.90735e-06L9.09423 13.5Z"
                                        fill="hsl(var(--grey))"
                                    />
                                </svg>
                            </div>
                            <div style={{ minWidth: '14.5%' }} >
                                <div style={{ width: '50px' }}>
                                    <p className="text-xs text-center">{t('Tolerance Lower')}</p>
                                    <Input
                                        value={data[0].markers[1]}
                                        type="text"
                                        name="inputField"
                                        control={control}
                                    />
                                </div>
                                <svg className="mx-4" xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 14" fill="none" >
                                    <path
                                        d="M9.09423 13.5L0.000967753 -3.17432e-07L18.1875 -1.90735e-06L9.09423 13.5Z"
                                        fill="hsl(var(--grey))"
                                    />
                                </svg>
                            </div>
                            <div style={{ minWidth: '14.3%' }} >
                                <div style={{ width: '50px' }}>
                                    <p className="text-xs text-center">{t('Committed Lower')}</p>
                                    <Input
                                        value={data[0].markers[2]}
                                        type="text"
                                        name="inputField"
                                        control={control}
                                    />
                                </div>
                                <svg className="mx-4" xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 14" fill="none" >
                                    <path
                                        d="M9.09423 13.5L0.000967753 -3.17432e-07L18.1875 -1.90735e-06L9.09423 13.5Z"
                                        fill="hsl(var(--grey))"
                                    />
                                </svg>
                            </div>
                            <div style={{ minWidth: '14.4%' }} >
                                <div style={{ width: '50px' }}>
                                    <p className="text-xs text-center">{t('Committed Target')}</p>
                                    <Input
                                        value={data[0].markers[3]}
                                        type="text"
                                        name="inputField"
                                        control={control}
                                    />
                                </div>
                                <svg className="mx-4" xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 14" fill="none" >
                                    <path
                                        d="M9.09423 13.5L0.000967753 -3.17432e-07L18.1875 -1.90735e-06L9.09423 13.5Z"
                                        fill="hsl(var(--grey))"
                                    />
                                </svg>
                            </div>
                            <div style={{ minWidth: '14.6%' }} >
                                <div style={{ width: '50px' }}>
                                    <p className="text-xs text-center">{t('Committed Upper')}</p>
                                    <Input
                                        value={data[0].markers[4]}
                                        type="text"
                                        name="inputField"
                                        control={control}
                                    />
                                </div>
                                <svg className="mx-4" xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 14" fill="none" >
                                    <path
                                        d="M9.09423 13.5L0.000967753 -3.17432e-07L18.1875 -1.90735e-06L9.09423 13.5Z"
                                        fill="hsl(var(--grey))"
                                    />
                                </svg>
                            </div>
                            <div style={{ minWidth: '14.5%' }} >
                                <div style={{ width: '50px' }} >
                                    <p className="text-xs text-center">{t('Best Possible')}</p>
                                    <Input
                                        value={data[0].markers[5]}
                                        type="text"
                                        name="inputField"
                                        control={control}
                                    />
                                </div>
                                <svg className="mx-4" xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 14" fill="none" >
                                    <path
                                        d="M9.09423 13.5L0.000967753 -3.17432e-07L18.1875 -1.90735e-06L9.09423 13.5Z"
                                        fill="hsl(var(--grey))"
                                    />
                                </svg>
                            </div>
                            <div style={{ minWidth: '1%' }} >
                                <div style={{ width: '50px' }}>
                                    <p className="text-xs text-center">{t('Stretch Value')}</p>
                                    <Input
                                        value={data[0].markers[6]}
                                        type="text"
                                        name="inputField"
                                        control={control}
                                    />
                                </div>
                                <svg className="mx-4" xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 14" fill="none" >
                                    <path
                                        d="M9.09423 13.5L0.000967753 -3.17432e-07L18.1875 -1.90735e-06L9.09423 13.5Z"
                                        fill="hsl(var(--grey))"
                                    />
                                </svg>
                            </div>
                        </div>
                        <div className="flex mt-[-47px] flex-row justify-center h-[150px] w-[100%]">
                            <ResponsiveBullet
                                data={data}
                                rangeColors={location?.pathname.includes('one-sided') ? [ 'hsl(var(--Extreme))', 'hsl(var(--yellow))', 'hsl(var(--light-green))', 'hsl(var(--medium-green))', 'hsl(var(--dark-green))' ] : [ 'hsl(var(--Extreme))', 'hsl(var(--yellow))', 'hsl(var(--light-green))', 'hsl(var(--yellow))', 'hsl(var(--Extreme))' ]}
                                ranges={[ 0, 50, 100, 150, 200, 250 ]}
                                margin={{ top: 50, right: 90, bottom: 50, left: 90 }}
                                spacing={46}
                                markerColors={['#000']}
                                measureSize={0.3}
                                markerSize={1}
                                titleAlign="start"
                                titleOffsetX={-70}
                                measureColors={['#339933']}
                                markerComponent={CustomMarker}
                                axisPosition="top"
                                axisTop={{
                                    tickSize: 5,
                                    tickPadding: 5,
                                    tickRotation: 0,
                                    legend: 'Value',
                                    legendPosition: 'middle',
                                    legendOffset: -36,
                                    format: value => {
                                        const index = tickValues.indexOf(value)
                                        return index !== -1 ? tickLabels[index] : value
                                    }
                                }}
                                theme={theme}
                            />
                        </div>
                    </div>
                </Card>
            </div>
            <div className='Indicator-footer'>
                <div className='flex p-10'>
                    <Button className='ml-auto' onClick={handleCancel} variant="outline">{t('Cancel')}</Button>
                    <Button className={'mr-5 ml-4'} onClick={handleSubmit(handleSubmitClick)} disabled={isSubmitting || isLoading}>{t('Submit')}</Button>
                </div>
            </div>
        </Fragment>
    )
}

export default IndicatorView
